import { combineReducers } from 'redux';
import { leadInfosReducer as leadInfos } from 'Store/lead-info/leadInfo.reducer';
import { booking } from './booking/booking.reducer';
import { calendarReducer as calendar } from './calendar/calendar.reducer';
import cms from './cms/cms.reducer';
import { facetingReducer as faceting } from './faceting/faceting.reducer';
import facetingTripInformation from './faceting-trip-information/facetingTripInformation.reducer';
import globalLoader from './global-loader/globalLoader.reducer';
import { memberSpace } from './member-space/memberSpace.reducer';
import { searchReducer as search } from './search/search.reducer';
import seller from './seller/sellerReducer';
import tripCriteria from './trip-criteria/tripCriteria.reducer';
import tripDateCriteria from './trip-date-criteria/tripDateCriteria.reducer';
import { priceRemoteReducer as priceRemote } from './price-remote/priceRemote.reducer';
import priceTicket from './priceTicket/priceTicket.reducer';
import tripInformation from './trip-information/tripInformation.reducer';
import { toast } from './toast/toast.reducer';
import userInfo from './user-info/reducers/userInfoReducer';
import validationSchema from './validation-schema/validationSchema.reducer';

export const rootReducer = combineReducers({
  booking,
  calendar,
  cms,
  faceting,
  facetingTripInformation,
  globalLoader,
  memberSpace,
  priceRemote,
  priceTicket,
  search,
  seller,
  tripDateCriteria,
  tripInformation,
  userInfo,
  leadInfos,
  tripCriteria,
  toast,
  validationSchema,
});

export type RootState = ReturnType<typeof rootReducer>;
